import { Task } from '../interfaces';
import { TaskItemState } from '../../store/interfaces/workflowItem';
import { currentWorkflowItemProvider } from './../../store/providers/currentWorkflowItemProvider';
import { getStore } from '../../store';
import axiosInstance from '../../common/utils/interceptor';
import { apiUrls } from './../../constants/apiUrls';
import updateExistingTaskState from './updateExistingTaskState';

const updateTasksAfterHurdlePass = async (): Promise<void> => {
  const { updateCurrentWorkflowItem } = currentWorkflowItemProvider();
  const currentWorkflowItem = getStore()?.state?.currentWorkflowItem;

  try {
    const res = await axiosInstance.get(apiUrls.GET_BASIC_TASKLIST_DETAILS);
    if (res && res.data && res.data.nestedItemsState?.length) {
      const itemStatusArray = res.data.nestedItemsState.filter(
        (itemState: TaskItemState) => itemState.state && JSON.parse(itemState.state).responseReuseType,
      );
      const config = currentWorkflowItem.configuration && JSON.parse(currentWorkflowItem.configuration);
      const tasks: Task[] = config?.configWidgetJSON?.tasks;

      // get tasks with updated item state
      const tasksWithUpdatedItemsState: Task[] = updateExistingTaskState(tasks, itemStatusArray);

      const updatedCurrentWorkflowItem = {
        ...currentWorkflowItem,
        configuration: JSON.stringify({
          ...config,
          configWidgetJSON: { ...config.configWidgetJSON, tasks: tasksWithUpdatedItemsState },
        }),
      };

      updateCurrentWorkflowItem(updatedCurrentWorkflowItem);
    }
  } catch (e) {
    console.error('error while fetching updated nested Items state', e);
  }
};

export default updateTasksAfterHurdlePass;
